var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"resend-code"},[(_vm.resendLoading)?_c('span',{staticClass:"spinner-circle resend"}):_c('a',{staticClass:"resend-link",on:{"click":_vm.resend}},[_vm._v(_vm._s(_vm.resendText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }